import { useHasPermission, Permission, useHasAnyPermission, useHasAllPermissions } from "~/hooks/permissions";

type Props = {
  permission?: Permission,
  anyPermission?: Permission[],
  allPermissions?: Permission[],
  children?: React.ReactNode,
}

const trueOrUndef = (x?: boolean): boolean => x || x === undefined;

export default function PermissionOrHide({ permission, anyPermission, allPermissions, children }: Props) {
  const hasPermission = useHasPermission(permission);
  const hasAnyPermission = useHasAnyPermission(anyPermission);
  const hasAllPermissions = useHasAllPermissions(allPermissions);

  if(hasPermission === undefined && hasAnyPermission === undefined && hasAllPermissions === undefined) {
    return null; // Default closed if not properly configured
  }

  return trueOrUndef(hasPermission) && trueOrUndef(hasAnyPermission) && trueOrUndef(hasAllPermissions) ? children : null
}
